import React from 'react';

import { currencyFormatter } from '../../../../components/shared/numberFormat';
import type { Account } from '../../../../generated-types';
import useTranslation from '../../../../hooks/useTranslation';
import { getBalanceNumbers } from '../../../../services/getBalanceService';

import './TotalAccountBalance.scss';

const isCurrencyAccount = (account: Account) => account.type === 'CURRENCY_ACCOUNT';
const ownsCurrencyAccount = (accounts: Account[]) => accounts.some(isCurrencyAccount);
const selectAccountWithAvailableBalance = (account: Account) => !isCurrencyAccount(account);

type TotalAccountBalanceProps = {
    accounts: Account[];
};

export const TotalAccountBalance: React.FC<TotalAccountBalanceProps> = ({ accounts }) => {
    const translated = useTranslation();

    const hasCurrencyAccounts = ownsCurrencyAccount(accounts);

    const totalBalance = accounts
        .filter(selectAccountWithAvailableBalance)
        .map((account) => getBalanceNumbers(account.balance, account.type)[0])
        .reduce((acc, cur) => acc + cur, 0);

    return (
        <div className="total-account-balance__wrapper">
            <div className="total-account-balance__content">
                {translated.accountsList.totalBalance}: <span>{currencyFormatter(totalBalance, 'NOK')}</span>
                <div className="total-account-balance__clause">
                    {hasCurrencyAccounts && (
                        <div className="total-account-balance__clause">
                            {translated.accountsList.clauseWithoutForeignCurrency}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
